import { DeepMap } from 'react-hook-form';
import { JobsiteUpdateInput } from 'apollo/generated/client-operations';
import { ensureNonUndefinedFields } from 'utils';
import { FormInputTypes, TypedFormInputs } from 'components/form';
import { EditJobsiteConfigurationFormData } from 'containers/jobsiteConfiguration/types';
import { Jobsite } from './types';
import {
  notificationsSectionInputs,
  getNotificationsSectionDefaultValues,
  getNotificationsSectionUpdateInput,
} from './notificationsSection';

export type EditJobsiteConfigTabFormData = Pick<
  EditJobsiteConfigurationFormData,
  'notifications'
>;

export const getFormInputs =
  (): TypedFormInputs<EditJobsiteConfigTabFormData> => {
    return {
      notifications: {
        element: FormInputTypes.Section,
        layout: '',
        elementProps: {
          title: 'Notifications',
          details: 'Set recipients for each notification type',
        },
        children: notificationsSectionInputs,
      },
    };
  };

type GetDefaultValuesArgs = {
  jobsite: Jobsite;
};

export const getDefaultValues = (
  args: GetDefaultValuesArgs,
): EditJobsiteConfigTabFormData => {
  const { jobsite } = args;
  const notifications = getNotificationsSectionDefaultValues(jobsite);
  return { notifications };
};

export const getJobsiteUpdateInput = (
  jobsite: Jobsite,
  data: EditJobsiteConfigTabFormData,
  dirtyFields: DeepMap<EditJobsiteConfigTabFormData, true>,
): JobsiteUpdateInput => {
  return ensureNonUndefinedFields<JobsiteUpdateInput>({
    jobsiteId: jobsite.jobsiteId,
    ...getNotificationsSectionUpdateInput(
      data.notifications,
      dirtyFields.notifications,
    ),
  });
};
